document.querySelectorAll('.faq-item').forEach(item => {
    const question = item.querySelector('.faq-item__q');
    const answer = item.querySelector('.faq-item__a');
  
    // 初期状態で max-height: 0（CSSに記述済み）
  
    question.addEventListener('click', () => {
      const isActive = item.classList.contains('is-active');
  
      // 全て閉じる（アコーディオンにしたいならここで全閉じ）
      document.querySelectorAll('.faq-item').forEach(i => {
        i.classList.remove('is-active');
        i.querySelector('.faq-item__a').style.maxHeight = null;
      });
  
      if (!isActive) {
        item.classList.add('is-active');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });